import React from 'react'
import icon from './assets/guitar_icon.svg'

export const SOR = {
  colors: {
    bestAvailablePerformanceColor: '#df1010'
  },
  themeIcon: <img width={20} height={20} src={icon} alt="theme icon" />
}
